import React, { PureComponent } from 'react';

import { View } from 'react-native';
import { createContainer } from '@dbk-legacy/muster/react';

import Button from '../../components/common/button';
import BlurModal from '../../components/common/blur-modal';

import styles from './change-password-success.styles';
import { ECREDENTIALS } from '../../constants';

class ChangePasswordSuccess extends PureComponent {
  constructor(props) {
    super(props);
    this.goBackToProfile = this.goBackToProfile.bind(this);
    this.state = {
      showModal: true
    }
  }

  componentWillUnmount = () => {
    this.props.auth.setChangePasswordForECred(null);
  }

  goBackToProfile() {
    const { terms, onChangePage, auth } = this.props;
    if (auth.changePasswordForECred === ECREDENTIALS.EPWD_RESET_COMPLETED) {
      onChangePage('/login');
      return;
    }
    if (this.props.auth.passwordExpired) {
      this.props.auth.setResetPasswordStatus(false);
      this.setState({
        showModal: false
      })
      this.props.routesAfterLogin(this.props.auth.entitlementPath);
    } else {
      this.props.onPress('/profile', true);
    }
  }

  getButtonTitle = (auth, isChangePwdInitiated, messages) => {
    if (isChangePwdInitiated) {
      return messages['app.forgotPassword.button.loginAgain'];
    }
    if (auth.passwordExpired) {
      return messages['app.auth.backtoportfolio'];
    }
    return messages['app.auth.backtoprofile'];
  }

  render() {
    const { i18n: { messages }, onPress, auth } = this.props;
    const isChangePwdInitiated = auth.changePasswordForECred === ECREDENTIALS.EPWD_RESET_COMPLETED;

    return (
      <BlurModal visible={this.state.showModal} doneVisible={false}>
        <div className="scene">
          <div className="row change-password">
            <div className="columns small-12 medium-push-3 medium-6 text-center">
              <div className="module">
                <div className="pad-bottom-50">
                  <h4>{messages['app.auth.changePasswordSuccess']}</h4>
                  <Button
                    title={this.getButtonTitle(auth, isChangePwdInitiated, messages)}
                    size="normal"
                    onPress={this.goBackToProfile}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </BlurModal>
    );
  }
}

export default createContainer({
  $queries: {
    onPress: { $call: 'ui.history.push' },
    i18n: {
      messages: true,
    },
    auth: {
      passwordExpired: true,
      setResetPasswordStatus: {
        $set: 'passwordExpired',
      },
      entitlementPath: true,
      changePasswordForECred: true,
      setChangePasswordForECred: { $set: 'changePasswordForECred'}
    },
    routesAfterLogin:{ $call: 'auth.routesAfterLogin' },
    terms: {
      showTermsConditions: true,
      showPrivacyAgreement: true,
      rmUserGroup: true,
    },
    loginTerms: {
      pdfLinkData: true,
    },
    onChangePage: {
      $call: 'ui.history.replace'
    }
  },
})(ChangePasswordSuccess);
